import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { ScheduleTemplateDetailPage } from "src/routes/libraries/schedules/ScheduleTemplateDetail";
import { ScheduleTemplatesPage } from "src/routes/libraries/schedules/ScheduleTemplatesPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as scheduleTemplatesPaths from "src/routing/domains/libraries/schedule-templates/scheduleTemplatesPaths";

/**
 * `/libraries/templates/schedule-templates/*` route tree.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page (legacy `PageHeader` chrome).
 */
export const scheduleTemplatesRoutes: RouteObject = {
  path: scheduleTemplatesPaths.scheduleTemplatesRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            { index: true, Component: ScheduleTemplatesPage },
            { path: scheduleTemplatesPaths.scheduleTemplateRoute.path, Component: ScheduleTemplateDetailPage },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
